module.exports = __webpack_public_path__ + "static/media/53.0345c62a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/53.jpg
// module id = 421
// module chunks = 0